import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Col } from 'react-bootstrap';
import { StyledGroup } from '../../shared/Input/styled';
import { Error } from './Error';
import { Label } from './Label';
import { OptionItem } from './OptionItem';
import { TooltipIcon } from './TooltipIcon';
import { StyledSelect } from '../../tier/styled';
import { useSelectSimple } from '../../../hooks/useShared';
import { Required } from '../../shared/Input/styled';
import { useSwitchDesign } from '../../../hooks/useSwitchDesign';

/**
 * Component select
 * @component
 * @param {*} dataName
 * @param {String} id
 * @param {Boolean} isRequired
 * @param {Boolean} isSetValue
 * @param {Boolean} isStaticData
 * @param {String} label
 * @param {String} message
 * @param {String} name
 * @param {Object} register
 * @param {Function} setValue
 * @param {String} text
 * @param {String} tooltip
 * @param {String} labelColor

 * @returns
 */
export const Select = ({
  dataName,
  id,
  isRequired,
  isSetValue = true,
  isStaticData = true,
  label,
  message,
  name,
  register,
  setValue,
  text,
  tooltip,
  labelColor = '',
  altErrorStyle,
  groupClassName = ''
}) => {
  const { t } = useTranslation();
  const { options, handleChange } = useSelectSimple(
    dataName, setValue, text, isStaticData, isSetValue);
  const { isNewDesign } = useSwitchDesign()

  return (
    <Col xs={12}>
      <StyledGroup className={`${groupClassName?.includes('mb-') ? `${groupClassName}` : `mb-4 ${groupClassName}`}`}>
        <Label htmlFor={ name } color={labelColor}>
          { label }{isRequired && (
            <Required className="text-danger">&nbsp;*</Required>)}
          { (tooltip) && (
                <TooltipIcon 
                  tooltipText={ tooltip } 
                  color={isNewDesign && 'third'} 
                />
              )}
        </Label>
        <StyledSelect
          { ...register }
          id={ name }
          name={ name }
          onChange={ handleChange }
        >
          <option value="">{ t("common.optionDefault") }</option>
          <OptionItem
            id={ id }
            options={ options || [] }
            text={ text }
            type="simple"
          />
        </StyledSelect>
        {message && (
          <Error 
            message={ message }
            altErrorMessageStyle={altErrorStyle}
          />
        )}
      </StyledGroup>
    </Col>
  );
};

Select.propTypes = {
  dataName: PropTypes.oneOfType([
    PropTypes.array.isRequired,
    PropTypes.string.isRequired
  ]),
  id: PropTypes.string.isRequired,
  isRequired: PropTypes.bool.isRequired,
  isSetValue: PropTypes.bool,
  isStaticData: PropTypes.bool,
  label: PropTypes.string.isRequired,
  message: PropTypes.string,
  name: PropTypes.string.isRequired,
  register: PropTypes.object,
  setValue: PropTypes.func,
  text: PropTypes.string.isRequired,
  tooltip: PropTypes.string
};
